import axios from "axios";

const apichatbot = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL_CHATBOT}`,
});

// request
apichatbot.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response
apichatbot.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    /*      error handling       */

    // const originalRequest = error.config;

    // expired token
    if (
      error.response.status === 401
      // &&originalRequest.url === 'http://127.0.0.1:3000/v1/auth/token'
    ) {
      // router.push('/login')
      return Promise.reject(error);
    }

    // refresh token
    // if (error.response.status === 401 && !originalRequest._retry) {
    //   originalRequest._retry = true
    //   const refreshToken = sessionStorageService.getRefreshToken()
    //   return axios
    //     .post('/auth/token', {
    //       refresh_token: refreshToken
    //     })
    //     .then(res => {
    //       if (res.status === 201) {
    //         sessionStorageService.setToken(res.data)
    //         axios.defaults.headers.common['Authorization'] =
    //           'Bearer ' + sessionStorageService.getAccessToken()
    //         return axios(originalRequest)
    //       }
    //     })
    // }
    return Promise.reject(error);
  }
);

export default apichatbot;
